import * as contentful from 'contentful';

export const client = contentful.createClient({
	space: '8wf8xjhhl5k5',
	accessToken: 'pgbYt-qSR47n8zme_v0491Dyds60RiYjuDr3XllIHrs'
});
